import React from 'react'

import { FontFamily, Text } from '@gousto-internal/citrus-react'

import type { StandardRecipeItem } from '@library/api-menu-experience'

import { CustomisationLabelWrapper } from '../RecipeTile.styles'

type CustomisationLabelProps = {
  recipe: StandardRecipeItem
}

export const CustomisationLabel = ({ recipe }: CustomisationLabelProps) => {
  const label = recipe.customisations?.label

  if (!label) {
    return null
  }

  return (
    <CustomisationLabelWrapper>
      <Text fontFamily={FontFamily.Bold}>{label}</Text>
    </CustomisationLabelWrapper>
  )
}
